import React, { ReactNode } from "react";

import DefaultConsent from "./defaultConsent";
import MapTileContentBlocker from "./mapTileContentBlocker";
import { getComplianceSettings, setComplianceSettings, setShowComplianceSettings } from "../../features/complianceConsentSlice";
import { useAppDispatch, useAppSelector } from "../../state/hooks";

import "./consent.scss";

interface ConsentProps {
  children: ReactNode;
  type?: string;
  closeModal?: () => void;
}

const Consent: React.FC<ConsentProps> = ({ children, type = "", closeModal = () => {} }) => {
  const externalContentEnabled = useAppSelector((state) => (
    state.complianceConsent.externalContentEnabled
  ));
  const dispatch = useAppDispatch();

  const defaultConsentType = type !== "static-map";
  const showDefault = defaultConsentType && !externalContentEnabled;
  const showMapBlocker = !defaultConsentType && !externalContentEnabled;

  const enableExternalContent = () => {
    dispatch(
      setComplianceSettings({ consents: { custom_consent: { status: 1 } } }),
    ).then(() => {
      dispatch(
        getComplianceSettings(),
      );
    });
  };

  const openCookieConsent = () => {
    dispatch(
      setShowComplianceSettings(true),
    );
  };

  if (children && externalContentEnabled) {
    return children;
  }

  let consentWall = <></>;

  if (showDefault) {
    consentWall = (
      <DefaultConsent
        openCookieConsent={openCookieConsent}
        enableExternalContent={enableExternalContent}
        type={type}
        closeModal={closeModal}
      />
    );
  } else if (showMapBlocker) {
    consentWall = <MapTileContentBlocker />;
  }

  return consentWall;
};

export default Consent;
